import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header() {
  return (
    <header className="site-header">
      <Link to="/" className="site-logo">Monailz'</Link>
      <nav className="site-nav">
        <Link to="/">Accueil</Link>
        <Link to="/reservation" className="nav-cta">Réserver</Link>
        <Link to="/login" className="nav-admin-link">Espace pro</Link>
      </nav>
    </header>
  );
}

export default Header;
